export default {"src":"/_next/static/media/black-chevron-left.18e88691.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};